import request from '@/utils/request'

const base = '/db/benefit-analysis'


// 设备月度使用时间排名
export function assetsMonthUseTime(query) {
  return request({
    url: base+'/assets-month-use-time',
    method: 'get',
    params:query
  })
}

// 设备月度使用时间排名报表
export function assetsMonthUseTimeReport(query) {
  return request({
    url: base+'/assets-month-use-time-report',
    method: 'get',
    params:query
  })
}


// 科室月度使用时间排名
export function deptMonthUseTime(query) {
  return request({
    url: base+`/dept-month-use-time`,
    method: 'get',
    params:query
  })
}

// 科室月度使用时间排名报表
export function deptMonthUseTimeReport(query){
  return request({
    url:base+`/dept-month-use-time-report`,
    method:'get',
    params:query
  })
}

// 设备收入vs成本收入
export function assetsIncomeCostAnalysis(query) {
  return request({
    url: base+`/assets-income-cost-analysis`,
    method: 'get',
    params:query
  })
}

// 设备收入vs成本收入报表
export function assetsIncomeCostAnalysisReport(query){
  return request({
    url: base+'/assets-income-cost-analysis-report',
    method: 'get',
    params:query
  })
}